import { jsx, jsxs } from "react/jsx-runtime";
const DotElement = ({ statusDotPosition, prefix }) => statusDotPosition === "inline" ? /* @__PURE__ */ jsxs("span", { className: `${prefix}status__dot-wrapper`, children: [
  "\u200A",
  /* @__PURE__ */ jsx("span", { className: `${prefix}status__dot` })
] }) : /* @__PURE__ */ jsx("span", { className: `${prefix}status__dot` });
var StatusDot_default = DotElement;
export {
  StatusDot_default as default
};
